// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const CollapsibleSectionContent = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 1rem;

  &:hover {
    color: var(--mb-color-core-brand);
  }
`;
